import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundDown',
})
export class RoundDownPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value === null || value === undefined) return '0.00';

    // Convert string to number and remove commas if present
    let num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
    
    if (isNaN(num)) return '0.00';

    // Round down to 2 decimal places
    let roundedValue = Math.floor(num * 100) / 100;

    // Format with commas
    return roundedValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
